import { queryOptions } from '@tanstack/react-query';
import { campaignInfluencerTagAPIClient } from '../campaignInfluencerTagAPIClient';
import { CAMPAIGN_INFLUENCER_TAG_KEYS } from './keys';

const TAG_CATALOG_STALE_TIME_MS = 60_000;

export const CAMPAIGN_INFLUENCER_TAG_QUERIES = {
  list: (campaignId: string) =>
    queryOptions({
      queryKey: CAMPAIGN_INFLUENCER_TAG_KEYS.list(campaignId),
      queryFn: () => campaignInfluencerTagAPIClient.listTags(campaignId),
      staleTime: TAG_CATALOG_STALE_TIME_MS,
    }),
};
